<template>
    <!-- 详情模块 -->
    <div class="form-wrapper">
        <div class="ft-box">
            <div class="ft-title aFlex">
                <Icon class="ft-title-mark" type="md-bookmark" />
                <span>企业基本信息</span>
            </div>
            <ul class="ft-form-wrapper">
                <li class="ft-form-item">
                    <div class="ft-th">企业名称</div>
                    <div class="ft-td ft-bold">{{formData.corpName}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">统一社会信用代码</div>
                    <div class="ft-td">{{formData.corpCode}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">企业法定代表人</div>
                    <div class="ft-td">
                        <span>{{formData.legalMan}}</span>
                        <div>{{formData.legalManIdCardNumber}}</div>
                    </div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">注册所在地</div>
                    <div class="ft-td">
                        {{formData.areaName}}
                    </div>
                </li>
                <li class="ft-form-item" style="width: 100%">
                    <div class="ft-th">企业经营地址</div>
                    <div class="ft-td">{{formData.address}}</div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">企业成立日期</div>
                    <div class="ft-td">
                        {{formData.registerDate}}
                    </div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">企业类型</div>
                    <div class="ft-td">
                        {{transfer(String(formData.corpType), dict && dict.copeRegisterType)}}
                    </div>
                </li>
                <li class="ft-form-item"  style="width: 100%">
                    <div class="ft-th">注册资本</div>
                    <div class="ft-td">
                        {{formData.factRegCapital}}
                    </div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">联系人</div>
                    <div class="ft-td">
                        {{formData.linkMan}}
                    </div>
                </li>
                <li class="ft-form-item">
                    <div class="ft-th">联系电话</div>
                    <div class="ft-td">
                        {{formData.linkTel}}
                    </div>
                </li>
            </ul>
        </div>
        <div class="ft-box">
            <div class="ft-title aFlex">
                <Icon class="ft-title-mark" type="md-bookmark" />
                <span>参建项目</span>
            </div>
            <Table border size="large"
                   :columns="tableColumns" :data="tableData" highlight-row>
                <template slot-scope="{ row, index }" slot="projectName">
                    <span class="ft-bold-blue link-span" @click="handleJump(row.projectId)">{{row.projectName}}</span>
                </template>
            </Table>
        </div>
    </div>
</template>
<style scoped>

</style>
<script>
    import {mapState} from 'vuex';
    export default {
        components: {

        },
        data(){
            return {
                corpId:'',
                formData:{
                    corpName:'',
                    corpCode:'',
                    legalMan:'',
                    legalManIdCardNumber:'',
                    areaName:'',
                    address:'',
                    registerDate:'',
                    corpType:'',
                    factRegCapital:'',
                    linkMan:'',
                    linkTel:'',

                },
                // tableColumns:[
                //     {
                //         title: '项目名称',
                //         slot: 'projectName',
                //         align:'center',
                //         minWidth:100
                //     },
                //     {
                //         title: '项目状态',
                //         key: 'prjStatus',
                //         align:'center'
                //     },
                //     {
                //         title: '项目分类',
                //         key: 'category',
                //         align:'center'
                //     },
                //     {
                //         title: '行政区划',
                //         key: 'areaName',
                //         align:'center'
                //     },
                //     {
                //         title: '开工时间',
                //         key: 'startDate',
                //         align:'center'
                //     },
                //     {
                //         title: '计划竣工时间',
                //         key: 'completeDate',
                //         align:'center'
                //     }
                // ],
                tableData:[],

            };
        },
        computed:{
            ...mapState(['dict']),
            tableColumns() {
                return [
                    {
                        title: '项目名称',
                        slot: 'projectName',
                        align:'center',
                        minWidth:100
                    },
                    {
                        title: '项目状态',
                        key: 'prjStatus',
                        align:'center'
                    },
                    {
                        title: '项目分类',
                        key: 'category',
                        align:'center'
                    },
                    {
                        title: '行政区划',
                        key: 'areaName',
                        align:'center'
                    },
                    {
                        title: '开工时间',
                        key: 'startDate',
                        align:'center'
                    },
                    {
                        title: '计划竣工时间',
                        key: 'completeDate',
                        align:'center'
                    }
                ]
            }
        },
        created(){
            this.corpId= this.$route.query.corpId;
            this.getPageData();
        },
        mounted(){

        },
        watch: {

        },
        methods: {
            transfer(oldValue,arr) {
                let newValue = '';
                if(arr){
                    for (let i=0;i<arr.length;i++){
                        if (arr[i].code === oldValue) {
                            newValue = arr[i].name;
                            break;
                        }
                    }
                }
                return newValue;
            },
            /* 跳转页面 */
            handleJump(projectId){
                this.$router.push({
                    name: 'projectDetail',
                    query: {
                        projectId:projectId
                    }
                });
            },
            /*取消返回*/
            handleCancel() {
                this.$router.go(-1);
            },
            /*获取页面信息*/
            getPageData(){
                this.axios({
                    method: 'get',
                    url:'/corp/detail',
                    params:{
                        corpId:this.corpId,
                    }
                }).then((response)=>{
                    if(response.data.success){
                        this.tableData=response.data.data.projects;
                        this.formData=response.data.data.corp;
                    }
                });
            },
        }
    };
</script>
